import { render } from "./SelectorCountry.vue?vue&type=template&id=10b20d58&scoped=true"
import script from "./SelectorCountry.vue?vue&type=script&lang=js"
export * from "./SelectorCountry.vue?vue&type=script&lang=js"

import "./SelectorCountry.vue?vue&type=style&index=0&id=10b20d58&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10b20d58"]])

export default __exports__